/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid, Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 250,
    height: 122,
    padding: theme.spacing(1, 2, 1, 2),
    borderRadius: 7,
    backgroundColor: "#2d3034",
    marginRight: 20,
  },
  title: {
    fontFamily: "Roboto",
    fontSize: 18,
    lineHeight: 1.33,
    textAlign: "left",
    color: "#fff",
  },
  divBackIcon: {
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    backgroundImage: "linear-gradient(91deg, #d233ff 1%, #ac0bce 99%)",
  },
  typoWorkersNumber: {
    fontFamily: "Roboto",
    fontSize: 26,
    fontWeight: 500,
    lineHeight: 1.31,
    textAlign: "left",
    color: "#fff",
    marginRight: 5,
  },
  typoWorkersLabel: {
    fontFamily: "Roboto",
    fontSize: 16,
    // lineHeight: 1.31,
    textAlign: "left",
    color: "#ccc",
  },
  typoWorkersNumber2: {
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    // lineHeight: 1.33,
    textAlign: "left",
    color: "#1ebc2e",
    marginRight: 5,
  },
  typoWorkersLabel2: {
    fontFamily: "Roboto",
    fontSize: 10,
    lineHeight: 1.25,
    textAlign: "left",
    color: "#ccc",
  },
}));

export default function SingleCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{
          marginBottom: 18,
        }}
      >
        <Typography className={classes.title}>{props.title}</Typography>

        <div className={classes.divBackIcon}>
          <FontAwesomeIcon
            icon={props.icon}
            style={{
              width: "19px",
              height: "15px",
              color: "#fff",
              borderRadius: "5px",
            }}
          />
        </div>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-end"
      >
        <Typography className={classes.typoWorkersNumber}>
          {props.number}
        </Typography>
        <Typography className={classes.typoWorkersLabel}>
          {props.active}
        </Typography>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Typography className={classes.typoWorkersNumber2}>
          {"+ " + props.new}
        </Typography>
        <Typography className={classes.typoWorkersLabel2}>
          el día de hoy
        </Typography>
      </Grid>
    </Card>
  );
}
